<template lang="pug">
  main
    NavBar
    ModalDelete(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:eliminar="eliminarMovimiento")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Comercios&nbsp
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaPeriodo'
                  :config="config"
                  class="input"
                )
          .column.is-1
            router-link.a.button.is-black.is-small.is-rounded(to="/Transportes/Tarjetas/Comercios/Nuevo")
              | Nuevo 
        .columns
          .column.is-12
            Tb_Comercios(:comercios="comerciosShow" @reloadTable="reloadTable" @deleteComercio="verModalEliminar")
        .columns.column-blanco
</template>

<script>
  import NavBar from '../layout/NavBarTransportes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import ModalDelete from '@/components/shared/ModalDelete.vue'
  import Tb_Comercios from './Tb_Comercios.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import InventarioServices from '@/services/inventario/inventario'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'Comercios',
    components: { NavBar, Loader, flatPickr, Tb_Comercios, ModalDelete },
    data() {
      return {
        isLoading: true,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        fechaPeriodo: moment().format('YYYY-MM'),
        comercios: [],
        comerciosShow: [],
        comerciosSelect: {},
        query: '',
        filter: 'ALL',
        result_query: '',
        modalStatus: false,
        titleModal: '',
        contentModal: '',
      }
    },
    methods: {
      iniciarComponente () {
        this.obtenerComercios()
      },

      obtenerComercios () {
        InventarioServices.getTarjetas_Comercios()
          .then( data => {
            this.comercios = data
            this.comerciosShow = this.comercios
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')      
          })
      },

      verModalEliminar (comercio) {
        this.comerciosSelect = comercio
        this.titleModal = `Eliminar Comercio`
        this.contentModal = `¿Desea eliminar el comercio ${comercio.nombre}?`
        this.modalStatus = true
      },

      eliminarMovimiento (result) {
        if (result === 'delete') {
          InventarioServices.deleteTarjeta_Comercio(this.comerciosSelect.id)
            .then( data => {
              this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done':'ban', 'OK')
              this.iniciarComponente()
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
        }
        this.contentModal = ''
        this.titleModal = ''
        this.comerciosSelect = {}
        this.modalStatus = false
      },

      reloadTable () {
        this.obtenerComercios()
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backToPage () {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/comercios/Comercios.vue